/* ============================================================
   FICHA — la etiqueta muestra la talla elegida: "Talla : XS"
   (17 ago 2026 · corregido 20 ago 2026)

   EN PAULINA JIMENEZ la etiqueta pone "Talla : XS" y cambia al pulsar otra.
   Aqui ponia solo "TALLA". No se puede hacer con CSS: hay que leer cual
   esta seleccionada y escribirlo.

   ⚠️⚠️ SOLO TOCA LA TALLA. NUNCA EL COLOR. ⚠️⚠️
   La primera version repintaba TODAS las cabeceras de opcion. El tema ya
   escribe el nombre del color el solo ("Color · Ciruela") y lo actualiza
   al cambiar de variante — pero este script se lo pisaba en cada
   repintado y lo dejaba clavado en el color con el que cargo la pagina.
   El sintoma: cambiabas de color y el nombre no cambiaba nunca.
   Por eso ahora hay un filtro por nombre de opcion. NO QUITARLO.

   COMO SE DETECTA LA SELECCIONADA, en este orden:
     1. aria-checked="true" o aria-selected="true"
     2. clase que contenga "--activo" o "--a"
     3. el input radio marcado dentro del boton

   ⚠️ Se guarda el texto original de la etiqueta en un data-, para poder
   reconstruir "Nombre : Valor" cada vez sin ir acumulando los dos puntos.
   Sin eso, a la tercera pulsacion pondria "Talla : S : M : L".
   ============================================================ */
(function () {
  'use strict';

  /* Que opciones se tocan. Solo las de talla; cualquier otra (color,
     largo, lo que venga) se deja como la pinta el tema. */
  var ES_TALLA = /talla|size/i;

  function seleccionado(cont) {
    return cont.querySelector('[aria-checked="true"]')
        || cont.querySelector('[aria-selected="true"]')
        || cont.querySelector('.producto-nazalea__valor--activo')
        || cont.querySelector('.producto-nazalea__valor--a')
        || (function () {
             var r = cont.querySelector('input:checked');
             return r ? (r.closest('.producto-nazalea__valor') || r.parentElement) : null;
           })();
  }

  function pintar() {
    var cabs = document.querySelectorAll('.producto-nazalea__opcion-cab');
    Array.prototype.forEach.call(cabs, function (cab) {
      var nombre = cab.querySelector('.producto-nazalea__opcion-nombre');
      if (!nombre) { return; }

      /* El filtro. Se mira el texto de base (lo de antes de los dos
         puntos) para que siga funcionando despues de haberlo reescrito. */
      var base = nombre.dataset.pnBase;
      if (!base) {
        base = nombre.textContent.replace(/\s*:.*$/, '').trim();
      }
      if (!ES_TALLA.test(base)) { return; }
      nombre.dataset.pnBase = base;

      var grupo = cab.parentElement;
      var valores = grupo ? grupo.querySelector('.producto-nazalea__valores') : null;
      if (!valores) { return; }

      var sel = seleccionado(valores);
      nombre.textContent = sel
        ? base + ' : ' + sel.textContent.replace(/\s+/g, ' ').trim()
        : base;
    });
  }

  function enganchar() {
    var vals = document.querySelectorAll('.producto-nazalea__valores');
    Array.prototype.forEach.call(vals, function (v) {
      if (v.dataset.pnEtq === '1') { return; }
      v.dataset.pnEtq = '1';
      v.addEventListener('click', function () { setTimeout(pintar, 30); });
      if (window.MutationObserver) {
        new MutationObserver(pintar).observe(v, {
          attributes: true, subtree: true,
          attributeFilter: ['class', 'aria-checked', 'aria-selected', 'checked']
        });
      }
    });
    pintar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else {
    enganchar();
  }
  document.addEventListener('shopify:section:load', enganchar);
  setTimeout(enganchar, 600);
})();